import React from "react";

const Features = () => {
    return (
        <div id="app-features" className={"guide-paragraph"}>
            <h2>
                2. Application features
            </h2>
            <p>
                The main function of the app is to remind you of work rests in order to improve your
                well-being
                and increase productivity.
            </p>
            <p>
                Application features:
            </p>
            <ul>
                <li>Usage the Pomodoro technique</li>
                <li>Tips on how to make a good break</li>
                <li>Time management with the ability to create different categories of tasks</li>
                <li>Individual settings for each category of tasks</li>
                <li>Configurable duration of periods – work / rest</li>
                <li>Notifications when changing periods</li>
                <li>Customization of notification ringtones, silent mode</li>
                <li>Statistics to track your results</li>
                <li>Backup in the cloud with linking to google account</li>
                <li>Various color schemes</li>
            </ul>
        </div>
    )
}

export default Features